/* eslint-disable prettier/prettier */
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useUserProfile } from '../../../hooks/useUserProfile';

import ProgramsPage from "../../../pages/ProgramsPage";
import AdminProgramsPage from "../../../pages/admin/AdminProgramsPage";
import ProgramDetailsPage from "../../../pages/ProgramDetailsPage";
import AdminEditProgramPage from "../../../pages/admin/AdminEditProgramPage";
import LearnerProgramDetailsPage from "../../../pages/learner/LearnerProgramDetailsPage";
import { useCourseCatalog, useCourseDetails } from '../../../hooks/useCourse';


const ProgramsSmartRouter: React.FC = () => {
  const { profile } = useUserProfile();
  const { id } = useParams();
  const role = profile?.rolename?.toLowerCase();

  const { course } = useCourseDetails(id!, profile?.id);
  
  console.log("Smart Router Role:", role);

	// ⏳ Wait until profile loads (IMPORTANT)
	if (!role) return null;

  // =========================
  // 🔹 DETAILS PAGE (/:id)
  // =========================
  if (id) {
    const canEditProgram =
  role === "superadmin" ||
  (
    (role === "coach" || role === "mentor") &&
    profile?.id === course?.programownerid
  );

if (canEditProgram) {
  return <AdminEditProgramPage />;
}

if (role === "coach" || role === "mentor") {
  return <ProgramDetailsPage />;
}
    
    if (role === "coachee") {
      return <LearnerProgramDetailsPage />;
    }



		return <Navigate to="/dashboard" replace />;
	}

	// =========================
	// 🔹 LISTING PAGE (/programs)
	// =========================
	if (role === 'superadmin') {
		return <AdminProgramsPage />;
	}

	if (role === 'coach' || role === 'coachee') {
		return <ProgramsPage />;
	}

	return <Navigate to="/dashboard" replace />;
};

export default ProgramsSmartRouter;
